export const rootNode = document.getElementById('marketing-finance-apps-root');

export const initParams = {
  data: JSON.parse(rootNode.dataset.data),
  formId: rootNode.dataset.formId,
  portalId: rootNode.dataset.portalId,
};
